<template>
  <div class="container" style="margin-top:40px; flex: 1;">
    <div class="row">
      <div class="col-sm-6 col-md-5 col-md-offset-4 login-col">
        <div class="panel panel-default">
          <div class="panel-heading">
            <strong>BIS Guias</strong>
          </div>
          <div class="panel-body">
            <form
              @submit.prevent="login()"
              role="form"
              action="/login"
              method="post"
            >
              <fieldset>
                <div class="row">
                  <div class="center-block">
                    <img class="profile-img" src="static/logo.svg" alt>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-10 col-md-offset-1 login-col">
                    <div class="form-group">
                      <b-input-group>
                        <b-input-group-text slot="prepend">
                          <i class="material-icons">person</i>
                        </b-input-group-text>
                        <b-form-input id="login-email-input" v-model="email" placeholder="Seu e-mail" required/>
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <b-input-group>
                        <b-input-group-text slot="prepend">
                          <i class="material-icons">lock</i>
                        </b-input-group-text>
                        <b-form-input
                          id="login-password-input"
                          type="password"
                          v-model="password"
                          placeholder="Sua senha"
                          required
                        />
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <input
                        id="login-submit-button"
                        type="submit"
                        class="btn btn-lg btn-primary btn-block"
                        value="Entrar"
                        :disabled="loading"
                      >
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <div class="panel-footer">
            Esqueceu a senha?
            <a
              role="button"
              href="javascript:void(0)"
              v-on:click="forgotPassoword"
            >Recupere aqui!</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from "../../service/LoginService.js";
import GuideService from "../../service/GuideService";
import axios from "axios";

export default {
  data() {
    return {
      email: "",
      password: "",
      loading: false
    };
  },
  created() {
    this.loginService = new LoginService();
    this.userService = new GuideService();
  },
  methods: {
    login() {
      this.loginService
        .login({ email: this.email, password: this.password })
        .then(async loginResponse => {
          let token = loginResponse.data.access_token;
          await this.$store.dispatch("login", { token: token });
          await this.$store.dispatch("fetchManualModificationDate");
          this.$router.push('/welcome');
        })
        .catch(error => {
          this.$store.dispatch("showAlert", {
            message: "Erro: Login ou senha incorretos",
            code: 0,
            style: "danger"
          });
          this.reset();
        });
    },
    reset() {
      this.password = "";
    },
    forgotPassoword() {
      if (!this.email) {
        alert("Digite o email a qual deseja resetar a senha.");
        return;
      }
      this.userService.sendResetPassword(this.email)
        .then(() => {
          this.$store.dispatch("showAlert", {
            message: "Email enviado! Verifique sua caixa de email.",
            code: 0,
            style: "success"
          });
          this.reset();
        })
        .catch(error => {
          this.$store.dispatch("showAlert", {
            message: error.response ? error.response.data.message : "Erro ao resetar senha!",
            code: 0,
            style: "danger"
          });
          this.reset();
        });
    }
  }
};
</script>

<style scoped>
.row {
  display: flex;
  align-items: center;
  justify-content: center;
}

.panel {
  margin-top: 100px;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
}

.panel-heading {
  padding: 5px 15px;
  text-align: center;
  background-color: #f5f5f5;
  border-color: #ddd;
  color: #163247 !important;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.panel-body {
  padding: 15px;
}

@media screen and (min-width: 767px) {
  .login-col {
    padding-right: 3px !important;
    padding-left: 3px !important;
  }
}

.panel-footer {
  padding: 1px 15px;
  color: #a0a0a0;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.profile-img {
  width: 98px;
  height: 69px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.btn-primary {
  background-color: #163247 !important;
  border-color: #042035 !important;
}

.btn-primary:hover {
  background-color: #042035 !important;
  border-color: #042035 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue